type Permission = {
  adminDashboard?: boolean;
  assessment?: boolean;
  earlyIntervention?: boolean;
  platformEnabled?: boolean;
  tutoringChat?: boolean;
};

type CoursePermission = {
  courseId: string;
  permission?: Permission;
};

const hasSomePermissionsForAssessment = (
  permissions?: CoursePermission[]
): boolean => {
  return !!permissions?.some(
    (permissionCourse) => permissionCourse?.permission?.assessment
  );
};

const hasSomePermissionsForIntervention = (
  permissions?: CoursePermission[]
): boolean => {
  return !!permissions?.some(
    (permissionCourse) => permissionCourse?.permission?.earlyIntervention
  );
};

const hasSomePermissionsForAdminDashboard = (
  permissions?: CoursePermission[]
): boolean => {
  return !!permissions?.some(
    (permissionCourse) => permissionCourse?.permission?.adminDashboard
  );
};

export {
  hasSomePermissionsForAdminDashboard,
  hasSomePermissionsForAssessment,
  hasSomePermissionsForIntervention,
};
export type { CoursePermission };
